module.exports = __webpack_public_path__ + "img/18-green.0fb2bd86.svg";